export default __webpack_public_path__ + "static/media/GDPR_compliant.198a2066.svg";